module.exports = __webpack_public_path__ + "img/wedding-dress.badca1cb.png";